export const header_links = [
  {
    path: "/",
    name: "Home",
  },
  {
    path: "/#about",
    name: "About",
  },
  {
    path: "/#faq",
    name: "FAQ",
  },
  {
    path: "/#contact",
    name: "Contact",
  },
];

export const footer_links = [
  {
    title: "Contact",
    links: [
      {
        name: "support@padicoins.com",
        path: "mailto:support@padicoins.com",
      },
      {
        name: "Call 09063615051",
        path: "tel:090-6361-5051",
      },
      {
        name: "FAQ",
        path: "/#faq",
      },
    ],
  },
  {
    title: "Company",
    links: [
      {
        name: "About Us",
        path: "/#about",
      },

      {
        name: "Terms and Conditions",
        path: "/terms-and-conditions",
      },
      {
        name: "Privacy Policy",
        path: "/privacy-policy",
      },
    ],
  },
  {
    title: "Services",
    links: [
      {
        name: "Buy Crypto",
      },
      {
        name: "Sell Crypto",
      },
      {
        name: "Trade Crypto",
      },
      {
        name: "Download Our App",
      },
    ],
  },
];
